import { Button, styled } from "@chakra-ui/react"
import { useLayoutEffect, useRef, useState } from "react"
import { FaUser } from "react-icons/fa"
import { FaPersonWalkingArrowLoopLeft } from "react-icons/fa6"
import "@fontsource/jua/400.css"
import { useIsMobileDevice } from "src/util/browser"

const Span = styled("span")

type Props = {
  type: "2D" | "3D" | "text"
  onClick: () => unknown
  text?: JSX.Element
  iconSize?: string
  borderRadius?: string
}

function PerspectiveBtn({
  type,
  text,
  onClick,
  iconSize = "55%",
  borderRadius,
  ...props
}: Props & React.CSSProperties) {
  const ref = useRef<HTMLButtonElement>()
  const [height, setHeight] = useState<number>(0)
  const isMobile = useIsMobileDevice()

  useLayoutEffect(() => {
    setHeight(ref.current?.getBoundingClientRect()?.height)
  }, [])
  props
  return (
    <Button
      ref={ref}
      onClick={isMobile ? null : onClick}
      onTouchStart={isMobile ? onClick : null}
      // height="unset"
      height="15%"
      width="60%"
      style={{
        aspectRatio: "4/2"
      }}
      bg="#212121"
      border={props.border ?? "4px solid currentColor"}
      borderRadius={borderRadius ?? `${height / 2}px`}
      outline="none"
      transition="background .25s ease"
      _hover={{
        bg: "black"
      }}
      _active={{}}
      _focus={{}}
    >
      {type === "2D" ? (
        <FaUser size={iconSize} />
      ) : type === "3D" ? (
        <FaPersonWalkingArrowLoopLeft size={iconSize} />
      ) : type === "text" ? (
        <Span fontFamily="Jua">{text}</Span>
      ) : (
        <>
          {import.meta.env.MODE === "development" ? (
            <>{new Error("Unhandled button type")}</>
          ) : (
            <></>
          )}
        </>
      )}
    </Button>
  )
}

export default PerspectiveBtn
